import { Button, GroupBox } from '@infotech-soe/erp-ui-kit';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { SchemaPreferencesPaneContainerProps } from './SchemaPreferencesPaneContainer';

const messages = defineMessages({
  title: {
    id: 'core.preferencesDialog.schemas',
    defaultMessage: 'Schemas',
  },
  purgeCache: {
    id: 'core.preferencesDialog.schemas.purgeCache',
    defaultMessage: 'Purge cache',
  },
});

const SchemaPreferencesPane: React.FC<SchemaPreferencesPaneContainerProps> = ({
  onPurgeCache,
}) => {
  const { formatMessage } = useIntl();

  return (
    <GroupBox label={formatMessage(messages.title)}>
      <GroupBox.Content>
        <Button
          label={formatMessage(messages.purgeCache)}
          onClick={onPurgeCache}
        />
      </GroupBox.Content>
    </GroupBox>
  );
};

export default SchemaPreferencesPane;
